export const UPDATE_UTENTE_LOGIN_CAMBIO_PASSWORD 	  		= 'UPDATE_UTENTE_LOGIN_CAMBIO_PASSWORD';
export const UPDATE_PASSWORD_LOGIN_CAMBIO_PASSWORD 	  		= 'UPDATE_PASSWORD_LOGIN_CAMBIO_PASSWORD';
export const UPDATE_PASSWORD_NUOVA_LOGIN_CAMBIO_PASSWORD 	= 'UPDATE_PASSWORD_NUOVA_LOGIN_CAMBIO_PASSWORD';
export const UPDATE_PASSWORD_CONFERMA_LOGIN_CAMBIO_PASSWORD = 'UPDATE_PASSWORD_CONFERMA_LOGIN_CAMBIO_PASSWORD';
export const SALVA_DATI_LOGIN_CAMBIO_PASSWORD  		        = 'SALVA_DATI_LOGIN_CAMBIO_PASSWORD';
export const MODIFICA_DATI_LOGIN_CAMBIO_PASSWORD  			= 'MODIFICA_DATI_LOGIN_CAMBIO_PASSWORD';

